import React from 'react';
import { UtilsBlock, Title5, Icon, TextLarge } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellTips.module.scss';

const TIP_KEYS = [
  { key: 'tip1', icon: 'camera' },
  { key: 'tip2', icon: 'edit' },
  { key: 'tip3', icon: 'euros' },
  { key: 'tip4', icon: 'quickresponse' },
  { key: 'tip5', icon: 'category-cars' },
  { key: 'tip6', icon: 'payable' },
] as const;

const SellTips = () => {
  const { t } = useI18nContext();

  return (
    <>
      <UtilsBlock mb={['m', 'xl', null]}>
        <UtilsBlock as="h5" textStyle={['title-4', null, 'title-2']} mb="xxs">
          <span>{t('sell.page.tips.title')}</span>
          <span className="Title-highlight">{t('sell.page.tips.titleHighlight')}</span>
        </UtilsBlock>
        <TextLarge color="text-secondary">{t('sell.page.tips.subtitle')}</TextLarge>
      </UtilsBlock>
      <ul className={Classes.grid}>
        {TIP_KEYS.map(({ key, icon }) => (
          <li key={key} className={Classes.tip}>
            <div className={Classes.iconWrap}>
              <Icon name={icon} color="text-brand-primary" />
            </div>
            <Title5>{t(`sell.page.tips.${key}.title`)}</Title5>
            <TextLarge color="text-secondary">{t(`sell.page.tips.${key}.body`)}</TextLarge>
          </li>
        ))}
      </ul>
    </>
  );
};

export default SellTips;
